import { ICON__plus } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { BUTTON__try_app } from '@/pages/_base/buttons/BUTTON__try_app';
import { ViewShortcutTrigger } from '@/pages/_base/shortcut_hint/ViewShortcutTrigger';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useTranslation } from 'react-i18next';
import { HOOK_COLLECTION__create } from '../_hooks/HOOK_COLLECTION__create';
import { WatcherShortcutCollectionsCreate } from '../_watchers/watcher_shortcut_collections_create';

export function C_BUTTON__collection_create() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_COLLECTIONS);

  const { is_authorized } = use_slice_user(['is_authorized']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const { create_collection, is_loading } = HOOK_COLLECTION__create();

  /*
   * HTML
   */

  if (!is_authorized) return <BUTTON__try_app />;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_CREATE)) return <PLACEHOLDER_bar_line />;

  /*
   * HTML
   */
  return (
    <>
      <WatcherShortcutCollectionsCreate />
      <ViewShortcutTrigger hint_shortcut_keys={[EShortcutType.COLLECTIONS_CREATE]}>
        <UI_PRIMITIVE__button_with_icon_animated
          Icon={ICON__plus}
          disabled={is_loading}
          iconClassNameBase={`!text-component-item-foreground !size-4 !duration-300
             `}
          iconClassNameHovered="!text-bar-foreground"
          variant="no-border-on-component"
          onClick={() => create_collection(false)}
          className={`p-0 rounded-lg  bg-bar  `}
        />
      </ViewShortcutTrigger>
    </>
  );
}
